import { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";

import { useTesterIdentity } from "./TesterIdentityProvider";

const SessionExpiredPanel = ({ message, onReauthed }) => {
  const { signIn } = useTesterIdentity();
  const [signingIn, setSigningIn] = useState(false);

  const handleReauth = async () => {
    setSigningIn(true);
    try {
      await signIn();
      onReauthed();
    } catch (err) {
      console.warn("[tester-chat] tester re-auth failed:", err?.message || err);
    } finally {
      setSigningIn(false);
    }
  };

  return (
    <Stack spacing={2} sx={{ p: 3, textAlign: "center" }}>
      <Typography variant="body2" color="textSecondary">
        {message}
      </Typography>
      <Button variant="contained" onClick={handleReauth} disabled={signingIn}>
        {signingIn ? "Signing in…" : "Sign in again"}
      </Button>
    </Stack>
  );
};

export default SessionExpiredPanel;
